<template>
    <div class="d-flex justify-content-between">
        <div>
            <div class="display-4">
                <span v-if="is_money()">
                    {{ $util.formatMoeda(valor) }}
                </span>
                <span v-else>
                    {{ valor }}
                </span>
            </div>
            <div class="text-muted" v-if="config">
                {{ config.unidade_de_medida }}
            </div>
        </div>
        <div>
            <i class="fa-4x" :class="config.icone" v-if="config && config.icone"></i>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: ['relatorio', 'config', 'query'],

    computed: { 
        valor: function () { 
            let dados = ( this.relatorio && this.relatorio.result && this.relatorio.result.data ) 
                ? this.relatorio.result.data
                : [];

            if ( this.config.filtros ) {
                dados = dados.filter(item => { 
                    return this.config.filtros.every(filtro => { 
                        return filtro.campo 
                            && filtro.campo.column_name
                            && item[filtro.campo.column_name] == filtro.valor;
                    });
                });
            }

            console.log('rel', this.config);
            console.log('dados', dados);

            if ( dados.length == 1 ) {

                if ( this.config.colunas ) {
                    return dados[0][this.config.colunas];
                } else { 
                    return _.values(dados[0])[0];
                }

            } else if ( dados.length > 1 ) {

                if ( this.config.colunas ) {

                    let maximo = null;
                    let numerador = null;
                    let denominador = null;

                    switch ( this.config.operacao ) {
                        case 'avg':
                            return dados.length
                                ? ( 
                                    dados.reduce((total, carry) => { 
                                        return total + parseFloat(carry[this.config.colunas]);
                                    }, 0) / dados.length 
                                )
                                : 0;

                        case 'rel':
                            numerador = dados.reduce((total, carry) => { 
                                return total + parseFloat(carry[this.config.colunas]);
                            }, 0); 

                            denominador = dados.reduce((total, carry) => { 
                                return total + parseFloat(carry[this.config['operacao-den']]);
                            }, 0);

                            return denominador != 0 ? numerador / denominador : 0;

                        case 'max':
                            return dados.reduce((max, carry) => { 
                                return Math.max(max, parseFloat(carry[this.config.colunas]));
                            }, 0);

                        case 'min':
                            maximo = dados.reduce((max, carry) => { 
                                return Math.max(max, parseFloat(carry[this.config.colunas]));
                            }, 0);

                            return dados.reduce((min, carry) => { 
                                return Math.min(min, parseFloat(carry[this.config.colunas]));
                            }, maximo);
                    
                        default:
                            return dados.reduce((total, carry) => { 
                                return total + parseFloat(carry[this.config.colunas]);
                            }, 0);
                    }

                    
                }

            }

            return "";
        }
    },

    methods: {

        is_money() {

            if(this.config.unidade_de_medida && this.config.unidade_de_medida.indexOf('$') >= 0) {
                return true
            } else {

                try {

                    const columns = this.query.config.columns;
                    const column = columns.find(column => column.column_name == this.config.colunas)

                    if(column.format == 'money') {
                        return true;
                    }

                    return false;
                    
                }catch(error) {
                    console.log(error)
                    return false;
                }

                
            }
            
        }
    }
}
</script>